export const PLAYING = 'PLAYING'
export const PAUSED = 'PAUSED'
